import { render, staticRenderFns } from "./PersonnelChanges.vue?vue&type=template&id=7d55b772"
import script from "./PersonnelChanges.vue?vue&type=script&lang=js"
export * from "./PersonnelChanges.vue?vue&type=script&lang=js"
import style0 from "./PersonnelChanges.vue?vue&type=style&index=0&id=7d55b772&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports